import { Routes, Route, useLocation } from "react-router-dom"
import { useEffect } from 'react';
import HomePage from "./HomePage"
import MainlandChinaPage from "./MainlandChinaPage"
import HongKongSARPage from "./HongKongSARPage"
import UnitedStatesPage from "./UnitedStatesPage"
import InnerHomePage from './InnerHomePage'
import SupportPage from './SupportPage'
import AboutPage from './AboutPage'
import PrivacyPolicyPage from './PrivacyPolicyPage'
import TermOfUsePage from './TermOfUsePage'
import DataProduct from './DataProducts'
import DataDetail from './DataDetail'
import { ProtectedRoute } from '@/components/ProtectedRoute/ProtectedRoute'
import { Toaster } from "sonner"
import { AuthProvider } from "@/context/AuthContext" 

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }, [pathname]);

  return null;
}

function App() {
  return (
    <AuthProvider>
      <div className="App">
        <ScrollToTop></ScrollToTop>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/mainland-china" element={<MainlandChinaPage />} />
          <Route path="/hongkong-sar" element={<HongKongSARPage />} />
          <Route path="/united-states" element={<UnitedStatesPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/support" element={<SupportPage />} />
          <Route path="/inner-page" element={<InnerHomePage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/term-of-use" element={<TermOfUsePage />} />
          {/* 受保护的路由 */}
          <Route path="/data-product" element={<ProtectedRoute><DataProduct /></ProtectedRoute>} />
          <Route path="/data-detail/:productKey" element={<ProtectedRoute><DataDetail /></ProtectedRoute>} />
        </Routes>
        <Toaster />
      </div>
    </AuthProvider>
  )
}

export default App
